export var NoteType;
(function (NoteType) {
    NoteType["BASIC"] = "basic";
    // TODO - phone call etc?
})(NoteType || (NoteType = {}));
export var NoteSyncStatus;
(function (NoteSyncStatus) {
    NoteSyncStatus["SYNCED"] = "synced";
    NoteSyncStatus["NOT_SYNCED"] = "not_synced";
    NoteSyncStatus["ERROR"] = "error";
    NoteSyncStatus["NOT_APPLICABLE"] = "not_applicable";
})(NoteSyncStatus || (NoteSyncStatus = {}));
export var NoteSource;
(function (NoteSource) {
    /** Created by our app */
    NoteSource["INTERNAL"] = "internal";
    /** Created by an external system & synced in */
    NoteSource["EXTERNAL"] = "external";
})(NoteSource || (NoteSource = {}));
export var NoteEntityType;
(function (NoteEntityType) {
    NoteEntityType["INVOICE"] = "invoice";
    NoteEntityType["CONTACT"] = "contact";
})(NoteEntityType || (NoteEntityType = {}));
//# sourceMappingURL=note.js.map